import styled from "styled-components";
import React from "react";
import {
  Grid,
  GridColumn as Col,
  GridRow as Row,
  Statistic,
} from "semantic-ui-react";
import { connect } from "react-redux";
import { entityGet } from "../../../helpers/filter";
import { RoleRequired } from "../../auth/role-required";
import { Currency } from "../../../containers/common/currency";
import { permissions } from "../../../constant/permissions";
import {
  DataTable,
  DataTableColumn,
} from "../../../components/common/datatable";
import { t } from "../../../constant/translations";
import { getAppCurrency } from "../../../helpers/currency";

const BlockFundSummary = ({ summary, block, user }) => {
  const totalCharges = summary
    ? summary.charges_total
    : { current: 0, overdue: 0 };

  return (
    <Grid relaxed>
      <RoleRequired
        admin={true}
        permission={permissions.billingAccountViewBalance}
      >
        <Row>
          <Col computer={16}>
            <Grid columns="equal" divided centered>
              <Col textAlign={"center"}>
                <Statistic
                  label={t("fund.balance")}
                  value={
                    <Statistic.Value>
                      <Currency amount={block.balance} />
                    </Statistic.Value>
                  }
                  size="mini"
                />
              </Col>
              <Col textAlign={"center"}>
                <Statistic
                  label={t("block.available")}
                  value={
                    <Statistic.Value>
                      <Currency amount={block.at_disposal} />
                    </Statistic.Value>
                  }
                  size="mini"
                />
              </Col>
            </Grid>
          </Col>
        </Row>
      </RoleRequired>

      <Row>
        <Col computer={16}>
          <DataTable data={block.funds} unstackable={true}>
            <DataTableColumn render={(fund) => fund.name} />
            <DataTableColumn
              name={t("block.current_liabilities")}
              align={"right"}
              render={(fund) => (
                <Currency amount={totalCharges.current[fund.name]} />
              )}
            />
            <DataTableColumn
              name={t("block.arrears")}
              align={"right"}
              render={(fund) => (
                <Currency amount={totalCharges.overdue[fund.name]} />
              )}
            />
            <DataTableColumn
              name={t("fund.balance")}
              align={"right"}
              hidden={
                !user.hasPermission(permissions.billingAccountViewBalance)
              }
              render={(fund) => <Currency amount={fund.balance} />}
            />
          </DataTable>
        </Col>
      </Row>
    </Grid>
  );
};

function mapStateToProps(state, props) {
  return {
    user: state.auth.user,
    summary: entityGet(
      state.billingSummary.entities,
      (e) => e.id === props.block.id
    ),
  };
}

export default connect(mapStateToProps)(BlockFundSummary);
